import React from 'react';

const ChartContext = React.createContext('chart');

export const ChartContextProvider = ChartContext.Provider;

export default ChartContext;
